
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export class IconASC extends Vue {
  @Prop({ default: 26 }) public size!: number;
  @Prop({ default: "#ffffff" }) public color!: string;
}
export default IconASC;
